'use strict';


// Export EBP Isabelle ISO-8859(-1?)
// https://www.convertcsv.com/csv-to-json.htm

export const CONST_TARIFS = [
 {
   "Code article": "ANGLE_GD",
   "Libellé": "Angle abri GRAND Lg 2100 RAL",
   "PV HT": "24,10000",
   "Poids": "3,15"
 },
 {
   "Code article": "ANGLE_PT",
   "Libellé": "Angle abri standard Lg 2100  RAL",
   "PV HT": "20,20000",
   "Poids": "2,10"
 },
 {
   "Code article": "ATG-G3/3",
   "Libellé": "Option ATG pour Abri G3 Long. 3 m + Kit traitement ISOFIBRE",
   "PV HT": "40,10000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G3/4",
   "Libellé": "Option ATG pour Abri G3 Long. 4 m + Kit traitement ISOFIBRE",
   "PV HT": "49,10000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G3/5",
   "Libellé": "Option ATG pour Abri G3 Long. 5 m + Kit traitement ISOFIBRE",
   "PV HT": "58,00000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G3/6",
   "Libellé": "Option ATG pour Abri G3 Long. 6 m + Kit traitement ISOFIBRE",
   "PV HT": "67,00000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G4/3",
   "Libellé": "Option ATG pour Abri G4 Long. 3 m + Kit traitement ISOFIBRE",
   "PV HT": "48,30000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G4/4",
   "Libellé": "Option ATG pour Abri G4 Long. 4 m + Kit traitement ISOFIBRE",
   "PV HT": "60,10000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G4/5",
   "Libellé": "Option ATG pour Abri G4 Long. 5 m + Kit traitement ISOFIBRE",
   "PV HT": "71,80000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G4/6",
   "Libellé": "Option ATG pour Abri G4 Long. 6 m + Kit traitement ISOFIBRE",
   "PV HT": "83,50000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G5/3",
   "Libellé": "Option ATG pour Abri G5 Long. 3 m + Kit traitement ISOFIBRE",
   "PV HT": "56,60000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G5/4",
   "Libellé": "Option ATG pour Abri G5 Long. 4 m + Kit traitement ISOFIBRE",
   "PV HT": "71,10000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G5/5",
   "Libellé": "Option ATG pour Abri G5 Long. 5 m + Kit traitement ISOFIBRE",
   "PV HT": "85,50000",
   "Poids": "0,00"
 },
 {
   "Code article": "ATG-G5/6",
   "Libellé": "Option ATG pour Abri G5 Long. 6 m + Kit traitement ISOFIBRE",
   "PV HT": "100,00000",
   "Poids": "0,00"
 },
 {
   "Code article": "B_PIGNON-G3-2.55",
   "Libellé": "Bardage PIGNON Prof. 3 m Haut. 2.55 m RAL",
   "PV HT": "315,00000",
   "Poids": "83,82"
 },
 {
   "Code article": "B_PIGNON-G3-3.3",
   "Libellé": "Bardage PIGNON Prof. 3 m Haut. 3.3 m RAL",
   "PV HT": "356,00000",
   "Poids": "130,84"
 },
 {
   "Code article": "B_PIGNON-G4-2.55",
   "Libellé": "Bardage PIGNON Prof. 4 m Haut. 2.55 m RAL",
   "PV HT": "362,00000",
   "Poids": "121,67"
 },
 {
   "Code article": "B_PIGNON-G4-3.3",
   "Libellé": "Bardage PIGNON Prof. 4 m Haut. 3.3 m RAL",
   "PV HT": "436,00000",
   "Poids": "163,20"
 },
 {
   "Code article": "B_PIGNON-G5-2.55",
   "Libellé": "Bardage PIGNON Prof. 5 m Haut. 2.55 m RAL",
   "PV HT": "392,00000",
   "Poids": "143,17"
 },
 {
   "Code article": "B_PIGNON-G5-3.3",
   "Libellé": "Bardage PIGNON Prof. 5 m Haut. 3.3 m RAL",
   "PV HT": "529,00000",
   "Poids": "195,35"
 },
 {
   "Code article": "B3-LP_BAS-2.3",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 3 m RAL",
   "PV HT": "168,00000",
   "Poids": "63,26"
 },
 {
   "Code article": "B3-LP_BAS-2.35",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 3 m RAL",
   "PV HT": "169,00000",
   "Poids": "64,16"
 },
 {
   "Code article": "B3-LP_BAS-2.4",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 3 m RAL",
   "PV HT": "170,00000",
   "Poids": "65,06"
 },
 {
   "Code article": "B3-LP_BAS-3.05",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 3.05 m  Long. 3 m RAL",
   "PV HT": "219,00000",
   "Poids": "76,82"
 },
 {
   "Code article": "B3-LP_BAS-3.1",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 3.1 m  Long. 3 m RAL",
   "PV HT": "220,00000",
   "Poids": "77,71"
 },
 {
   "Code article": "B3-LP_BAS-3.15",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 3.15 m Long.. 3 m RAL",
   "PV HT": "221,00000",
   "Poids": "78,61"
 },
 {
   "Code article": "B3-LP_HAUT-2.55",
   "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long.. 3 m RAL",
   "PV HT": "175,00000",
   "Poids": "68,10"
 },
 {
   "Code article": "B3-LP_HAUT-3.3",
   "Libellé": "Bardage Long Pan HAUT Haut. 3.3 m Long. 3 m RAL",
   "PV HT": "225,00000",
   "Poids": "81,66"
 },
 {
   "Code article": "B3-LPBAS_RP-2.3",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 3 m + Réservation Porte RAL",
   "PV HT": "322,00000",
   "Poids": "65,06"
 },
 {
   "Code article": "B3-LPBAS_RP-2.35",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 3 m + Réservation Porte RAL",
   "PV HT": "324,00000",
   "Poids": "94,56"
 },
 {
   "Code article": "B3-LPBAS_RP-2.4",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 3 m + Réservation Porte RAL",
   "PV HT": "326,00000",
   "Poids": "96,08"
 },
 {
   "Code article": "B3-LPH_RP-2.55",
   "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 3 m + Réservation Porte RAL",
   "PV HT": "332,00000",
   "Poids": "100,94"
 },
 {
   "Code article": "B4-LP_BAS-2.3",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 4 m RAL",
   "PV HT": "206,00000",
   "Poids": "84,19"
 },
 {
   "Code article": "B4-LP_BAS-2.35",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 4 m RAL",
   "PV HT": "208,00000",
   "Poids": "85,39"
 },
 {
   "Code article": "B4-LP_BAS-2.4",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 4 m RAL",
   "PV HT": "209,00000",
   "Poids": "86,59"
 },
 {
   "Code article": "B4-LP_BAS-3.05",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 3.05 m  Long. 4 m RAL",
   "PV HT": "271,00000",
   "Poids": "102,27"
 },
 {
   "Code article": "B4-LP_BAS-3.1",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 3.1 m  Long.  4 m RAL",
   "PV HT": "273,00000",
   "Poids": "103,47"
 },
 {
   "Code article": "B4-LP_BAS-3.15",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 3.15 m Long. 4 m RAL",
   "PV HT": "274,00000",
   "Poids": "104,67"
 },
 {
   "Code article": "B4-LP_HAUT-2.55",
   "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 4 m RAL",
   "PV HT": "215,00000",
   "Poids": "90,65"
 },
 {
   "Code article": "B4-LP_HAUT-3.3",
   "Libellé": "Bardage Long Pan HAUT Haut. 3.3 m  Long. 4 m RAL",
   "PV HT": "280,00000",
   "Poids": "108,73"
 },
 {
   "Code article": "B4-LPBAS_RP-2.3",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 4 m + Réservation Porte RAL",
   "PV HT": "338,00000",
   "Poids": "101,89"
 },
 {
   "Code article": "B4-LPBAS_RP-2.35",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 4 m + Réservation Porte RAL",
   "PV HT": "340,00000",
   "Poids": "103,71"
 },
 {
   "Code article": "B4-LPBAS_RP-2.4",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 4 m + Réservation Porte RAL",
   "PV HT": "343,00000",
   "Poids": "105,54"
 },
 {
   "Code article": "B4-LPH_RP-2.55",
   "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 4 m + Réservation Porte  RAL",
   "PV HT": "351,00000",
   "Poids": "0,00"
 },
 {
   "Code article": "B5-LP_BAS-2.3",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 5 m RAL",
   "PV HT": "252,00000",
   "Poids": "106,59"
 },
 {
   "Code article": "B5-LP_BAS-2.35",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 5 m RAL",
   "PV HT": "254,00000",
   "Poids": "108,08"
 },
 {
   "Code article": "B5-LP_BAS-2.4",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 5 m RAL",
   "PV HT": "256,00000",
   "Poids": "109,58"
 },
 {
   "Code article": "B5-LP_BAS-3.05",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 3.05 m  Long. 5 m RAL",
   "PV HT": "338,00000",
   "Poids": "127,73"
 },
 {
   "Code article": "B5-LP_BAS-3.1",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 3.1 m  Long. 5 m RAL",
   "PV HT": "340,00000",
   "Poids": "129,23"
 },
 {
   "Code article": "B5-LP_BAS-3.15",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 3.15 m Long. 5 m RAL",
   "PV HT": "342,00000",
   "Poids": "130,73"
 },
 {
   "Code article": "B5-LP_HAUT-2.55",
   "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 5 m RAL",
   "PV HT": "263,00000",
   "Poids": "114,66"
 },
 {
   "Code article": "B5-LP_HAUT-3.3",
   "Libellé": "Bardage Long Pan HAUT Haut. 3.3 m Long. 5 m RAL",
   "PV HT": "349,00000",
   "Poids": "135,80"
 },
 {
   "Code article": "B5-LPBAS_RP-2.3",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 5 m + Réservation Porte RAL",
   "PV HT": "382,00000",
   "Poids": "134,89"
 },
 {
   "Code article": "B5-LPBAS_RP-2.35",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 5 m + Réservation Porte RAL",
   "PV HT": "385,00000",
   "Poids": "137,02"
 },
 {
   "Code article": "B5-LPBAS_RP-2.4",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 5 m + Réservation Porte  RAL",
   "PV HT": "388,00000",
   "Poids": "139,14"
 },
 {
   "Code article": "B5-LPH_RP-2.55",
   "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 5 m + Réservation Porte  RAL",
   "PV HT": "397,00000",
   "Poids": "146,03"
 },
 {
   "Code article": "B6-LP_BAS-2.3",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 6 m RAL",
   "PV HT": "290,00000",
   "Poids": "127,52"
 },
 {
   "Code article": "B6-LP_BAS-2.35",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 6 m RAL",
   "PV HT": "293,00000",
   "Poids": "129,31"
 },
 {
   "Code article": "B6-LP_BAS-2.4",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 6 m RAL",
   "PV HT": "295,00000",
   "Poids": "131,11"
 },
 {
   "Code article": "B6-LP_BAS-3.05",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 3.05 m  lLong. 6 m RAL",
   "PV HT": "399,00000",
   "Poids": "153,19"
 },
 {
   "Code article": "B6-LP_BAS-3.1",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 3.1 m  Long. 6 m RAL",
   "PV HT": "401,00000",
   "Poids": "154,98"
 },
 {
   "Code article": "B6-LP_BAS-3.15",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 3.15 m Long. 6 m RAL",
   "PV HT": "404,00000",
   "Poids": "156,78"
 },
 {
   "Code article": "B6-LP_HAUT-2.55",
   "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 6 m RAL",
   "PV HT": "304,00000",
   "Poids": "137,20"
 },
 {
   "Code article": "B6-LP_HAUT-3.3",
   "Libellé": "Bardage Long Pan HAUT Haut. 3.3 m Long. 6 m RAL",
   "PV HT": "412,00000",
   "Poids": "162,87"
 },
 {
   "Code article": "B6-LPBAS_RP-2.3",
   "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 6 m + Réservation Porte RAL",
   "PV HT": "393,00000",
   "Poids": "143,75"
 },
 {
   "Code article": "B6-LPBAS_RP-2.35",
   "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 6 m + Réservation Porte RAL",
   "PV HT": "397,00000",
   "Poids": "146,18"
 },
 {
   "Code article": "B6-LPBAS_RP-2.4",
   "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 6 m + Réservation Porte RAL",
   "PV HT": "400,00000",
   "Poids": "148,60"
 },
 {
   "Code article": "B6-LPH_RP-2.55",
   "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 6 m + Réservation Porte  RAL",
   "PV HT": "410,00000",
   "Poids": "187,95"
 },
 {
   "Code article": "BANDEAU_FAITAGE",
   "Libellé": "Bandeau de faîtage (en 2 éléments) Lg 2100 RAL...",
   "PV HT": "32,90000",
   "Poids": "3,50"
 },
 {
   "Code article": "FAITIERE_PLATE",
   "Libellé": "Faîtière plate Lg 2100 RAL...",
   "PV HT": "16,50000",
   "Poids": "2,10"
 },
 {
   "Code article": "FAITIERE_SOLIN",
   "Libellé": "Faîtière en solin crantée Lg 2100 RAL...",
   "PV HT": "29,00000",
   "Poids": "2,10"
 },
 {
   "Code article": "LIVRAISON",
   "Libellé": "Livraison et déchargement hors îles et stations de montagne",
   "PV HT": "0,00000",
   "Poids": "0,00"
 },
 {
   "Code article": "PACL",
   "Libellé": "Pince pour réalisation de larmier en bas de pente pour tôle ATG PRO",
   "PV HT": "19,00000",
   "Poids": "0,00"
 },
 {
   "Code article": "REJET_EAU",
   "Libellé": "Rejet d'eau Lg 2100 RAL...",
   "PV HT": "21,50000",
   "Poids": "1,58"
 },
 {
   "Code article": "REM-QTE",
   "Libellé": "Remise quantité",
   "PV HT": "-145,00000",
   "Poids": "0,00"
 },
 {
   "Code article": "RIVE_GDE",
   "Libellé": "Rive abri GRANDE Lg 2100 RAL...",
   "PV HT": "23,00000",
   "Poids": "2,52"
 },
 {
   "Code article": "RIVE_PTE",
   "Libellé": "Rive abri standard Lg 2100 RAL...",
   "PV HT": "21,50000",
   "Poids": "2,10"
 },
 {
   "Code article": "RIVE_SOLIN",
   "Libellé": "Rive solin Lg 2100 RAL...",
   "PV HT": "19,00000",
   "Poids": "2,10"
 },
 {
   "Code article": "SP-G3-2.55/3",
   "Libellé": "Abri Simple pente Prof.3 m Haut 2.55 m -5% Long. 3 m RAL",
   "PV HT": "1 014,00000",
   "Poids": "252,00"
 },
 {
   "Code article": "SP-G3-2.55/4",
   "Libellé": "Abri Simple pente Prof.3 m Haut 2.55 m -5% Long. 4 m RAL",
   "PV HT": "1 084,00000",
   "Poids": "290,52"
 },
 {
   "Code article": "SP-G3-2.55/5",
   "Libellé": "Abri Simple pente Prof.3 m Haut 2.55 m -5% Long. 5 m RAL",
   "PV HT": "1 167,00000",
   "Poids": "328,86"
 },
 {
   "Code article": "SP-G3-2.55/6",
   "Libellé": "Abri Simple pente Prof. 3 m Haut 2.55 m -5% Long. 6 m RAL",
   "PV HT": "1 259,00000",
   "Poids": "372,85"
 },
 {
   "Code article": "SP-G3-3.3/3",
   "Libellé": "Abri Simple pente Prof.3 m Haut 3.3 m -5% Long. 3 m RAL",
   "PV HT": "1 100,00000",
   "Poids": "303,79"
 },
 {
   "Code article": "SP-G3-3.3/4",
   "Libellé": "Abri Simple pente Prof.3 m Haut 3.3 m -5% Long. 4 m RAL",
   "PV HT": "1 171,00000",
   "Poids": "348,50"
 },
 {
   "Code article": "SP-G3-3.3/5",
   "Libellé": "Abri Simple pente Prof.3 m Haut 3.3 m -5% Long. 5 m RAL",
   "PV HT": "1 256,00000",
   "Poids": "401,18"
 },
 {
   "Code article": "SP-G3-3.3/6",
   "Libellé": "Abri Simple pente Prof. 3 m Haut 3.3 m -5% Long. 6 m RAL",
   "PV HT": "1 349,00000",
   "Poids": "447,79"
 },
 {
   "Code article": "SP-G4-2.55/3",
   "Libellé": "Abri Simple pente Prof. 4 m Haut 2.55 m -5% Long. 3 m RAL",
   "PV HT": "1 071,00000",
   "Poids": "284,44"
 },
 {
   "Code article": "SP-G4-2.55/4",
   "Libellé": "Abri Simple pente Prof. 4 m Haut 2.55 m -5% Long. 4 m RAL",
   "PV HT": "1 153,00000",
   "Poids": "328,95"
 },
 {
   "Code article": "SP-G4-2.55/5",
   "Libellé": "Abri Simple pente Prof. 4 m Haut 2.55 m -5% Long. 5 m RAL",
   "PV HT": "1 242,00000",
   "Poids": "373,28"
 },
 {
   "Code article": "SP-G4-2.55/6",
   "Libellé": "Abri Simple pente Prof. 4 m Haut 2.55 m -5% Long. 6 m RAL",
   "PV HT": "1 351,00000",
   "Poids": "425,80"
 },
 {
   "Code article": "SP-G4-3.3/3",
   "Libellé": "Abri Simple pente Prof. 4 m Haut 3.3 m -5% Long. 3 m RAL",
   "PV HT": "1 157,00000",
   "Poids": "355,57"
 },
 {
   "Code article": "SP-G4-3.3/4",
   "Libellé": "Abri Simple pente Prof. 4 m Haut 3.3 m -5% Long. 4 m RAL",
   "PV HT": "1 238,00000",
   "Poids": "412,56"
 },
 {
   "Code article": "SP-G4-3.3/5",
   "Libellé": "Abri Simple pente Prof. 4 m Haut 3.3 m -5% Long. 5 m RAL",
   "PV HT": "1 329,00000",
   "Poids": "477,50"
 },
 {
   "Code article": "SP-G4-3.3/6",
   "Libellé": "Abri Simple pente Prof. 4 m Haut 3.3 m -5% Long. 6 m RAL",
   "PV HT": "1 434,00000",
   "Poids": "536,38"
 },
 {
   "Code article": "SP-G5-2.55/3",
   "Libellé": "Abri Simple pente Prof. 5 m Haut 2.55 m -5% Long. 3 m RAL",
   "PV HT": "1 147,00000",
   "Poids": "333,34"
 },
 {
   "Code article": "SP-G5-2.55/4",
   "Libellé": "Abri Simple pente Prof. 5 m Haut 2.55 m -5% Long. 4 m RAL",
   "PV HT": "1 242,00000",
   "Poids": "389,64"
 },
 {
   "Code article": "SP-G5-2.55/5",
   "Libellé": "Abri Simple pente Prof. 5 m Haut 2.55 m -5% Long. 5 m RAL",
   "PV HT": "1 348,00000",
   "Poids": "446,74"
 },
 {
   "Code article": "SP-G5-2.55/6",
   "Libellé": "Abri Simple pente Prof. 5 m Haut 2.55 m -5% Long. 6 m RAL",
   "PV HT": "1 471,00000",
   "Poids": "511,60"
 },
 {
   "Code article": "SP-G5-3.3/3",
   "Libellé": "Abri Simple pente Prof. 5 m Haut 3.3 m -5% Long. 3 m RAL",
   "PV HT": "1 243,00000",
   "Poids": "390,22"
 },
 {
   "Code article": "SP-G5-3.3/4",
   "Libellé": "Abri Simple pente Prof. 5 m Haut 3.3 m -5% Long. 4 m RAL",
   "PV HT": "1 338,00000",
   "Poids": "453,18"
 },
 {
   "Code article": "SP-G5-3.3/5",
   "Libellé": "Abri Simple pente Prof. 5 m Haut 3.3 m -5% Long. 5 m RAL",
   "PV HT": "1 447,00000",
   "Poids": "524,15"
 },
 {
   "Code article": "SP-G5-3.3/6",
   "Libellé": "Abri Simple pente Prof. 5 m Haut 3.3 m -5% Long. 6 m RAL",
   "PV HT": "1 570,00000",
   "Poids": "589,09"
 },
 {
   "Code article": "TRANS-G3",
   "Libellé": "Option Translucides pour Abris G3 Long. 2 m qté : 2 tôles",
   "PV HT": "54,00000",
   "Poids": "0,00"
 },
 {
   "Code article": "TRANS-G4",
   "Libellé": "Option Translucides pour Abris G4 Long. 2,5 m qté : 2 tôles",
   "PV HT": "60,00000",
   "Poids": "0,00"
 },
 {
   "Code article": "TRANS-G5",
   "Libellé": "Option Translucides pour Abris G5 Long. 2 m qté : 2 tôles",
   "PV HT": "54,00000",
   "Poids": "0,00"
 }
];
